// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__-aKyC","footer":"Form_footer__V9pUm"};